var _path, _g, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_1128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1234_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000156403H53.9998V54H0V0.000156403Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1234_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2627 49.0095V53.21",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7314 49.0095V53.21",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.71 7.6738V13.2207",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1234_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000156403H53.9998V54H0V0.000156403Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1234_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4209 49.0577V50.6419C6.4209 52.0601 7.57061 53.21 8.98905 53.21H45.0096C46.4278 53.21 47.5776 52.0601 47.5776 50.6419V43.0019C47.5776 39.7814 45.4551 36.9462 42.3651 36.039L39.0841 35.0758L26.9993 42.2569L14.9152 35.0762L11.634 36.0393C8.54366 36.9463 6.4209 39.7816 6.4209 43.0023V45.3597",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0838 35.0758L31.7322 30.274C31.7322 33.3462 30.8404 36.3524 29.165 38.9275L26.999 42.2568",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 35.0758L22.2657 30.274C22.2657 33.3462 23.1575 36.3524 24.8328 38.9275L26.999 42.2568",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3344 13.3304V15.7188C20.3344 16.6771 19.5575 17.4541 18.5991 17.4541H16.876V20.2916C16.876 21.0167 17.4638 21.6045 18.1888 21.6045C18.4176 21.6045 18.6038 21.7837 18.6182 22.012C18.8951 26.4013 22.5404 29.876 26.9994 29.876C31.4585 29.876 35.1039 26.4013 35.3807 22.012C35.3952 21.7837 35.5812 21.6045 35.81 21.6045C36.5351 21.6045 37.123 21.0167 37.123 20.2916V17.4541H35.3998C34.4414 17.4541 33.6645 16.6771 33.6645 15.7188V13.3304",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2627 28.4105V30.2764L22.2662 30.2742",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7324 30.2744V28.4128",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9889 7.88147L28.8911 7.4982C27.6337 7.34272 26.362 7.34276 25.1047 7.49831L18.1086 8.36399L16.2256 8.59697V12.5538C16.2256 12.939 16.5064 13.2578 16.8743 13.3188C16.9164 13.326 16.9591 13.3298 17.0018 13.3301H36.9971C37.0396 13.3301 37.0808 13.3258 37.1213 13.3193C37.4909 13.2596 37.7735 12.9402 37.7735 12.5538V8.59697L35.8868 8.36357L35.665 8.33625",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1211 17.4531V13.3187",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.874 13.3191L16.8757 17.4541",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7712 8.59647L43.1897 7.67362C44.1155 7.51594 44.2058 6.22121 43.3108 5.93666L27.2691 0.834203C27.0924 0.777986 26.9026 0.777986 26.7259 0.834203L10.684 5.93666C9.78914 6.22121 9.87942 7.51594 10.8052 7.67362L16.2252 8.59668",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03295 16.2704L7.96423 22.5433C7.8633 23.1354 8.31945 23.6758 8.9202 23.6758H12.5007C13.1013 23.6758 13.5574 23.1354 13.4566 22.5433L12.388 16.2704",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3873 14.0682C12.3873 13.8435 12.298 13.628 12.1391 13.4691C11.9802 13.3102 11.7647 13.2209 11.5399 13.2209H9.87956C9.65483 13.2209 9.43931 13.3102 9.2804 13.4691C9.1215 13.628 9.03223 13.8435 9.03223 14.0682V16.2705H12.3873V14.0682Z",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0335 34.9262C29.7907 35.1999 28.4287 35.3516 26.9997 35.3516C25.5706 35.3516 24.2087 35.1999 22.9658 34.9262",
    stroke: "#0095DF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent1);
export default __webpack_public_path__ + "static/media/student-1.bf58024eaca9da9809a41dec087311f4.svg";
export { ForwardRef as ReactComponent };